import React, { useState } from "react";
import { ButtonBase, colors, Grid, Hidden, Typography } from "@material-ui/core";

function BarcodeImg(props) {
    const { AutoOptions, showLogo, showItem ,data} = props;

    const width = 2;
    const hight = 30;

    return (
        <div>
            {showLogo && AutoOptions.Found[0]?.Logo != null ?
                (
                    <ButtonBase >
                        {
                            <img
                                src={`data:image/jpeg;base64,${AutoOptions?.Found[0]?.Logo}`}
                                // style={{ height: 40, width: 50 }}
                                style={{ height: 55, width: 65 }}
                            />
                        }
                    </ButtonBase>
                ) : showItem && data?.img != null ?
                    <ButtonBase >
                        {
                            <img
                                src={`data:image/jpeg;base64,${data?.img}`}
                                style={{ height: 55, width: 65 }}
                            />
                        }
                    </ButtonBase> : null}
        </div>

    );
}

export default BarcodeImg;
